// extracted by mini-css-extract-plugin
export default {"Placeholder14Wrap":"AccountAndPwdForm_Placeholder14Wrap__-4Qbb","PasswordInput":"AccountAndPwdForm_PasswordInput__Lg9MZ","ForgotPwd":"AccountAndPwdForm_ForgotPwd__3CfFD"};